export class TipoVehiculoModel {

  id: number;
  nombre: string;
  descripcion: string;

  constructor() {
    this.id = null;
    this.nombre = '';
    this.descripcion = '';
  }
}
